module.exports = __webpack_public_path__ + "img/ES3117.f4988959.png";